import React from 'react';
import { MessageCircle, Award, Users, CheckCircle } from 'lucide-react';

const Admissions = () => {
  // URL directa de WhatsApp con mensaje predeterminado
  const whatsappMessage = "Hola! Quiero aplicar a la Beca Libertad de Urpe School";
  const whatsappLink = `https://wa.me/14702972453?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="admissions" className="py-32 bg-gradient-to-b from-black via-teal-950/10 to-black relative overflow-hidden">
      {/* Glow effects */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-teal-400 text-sm uppercase tracking-widest font-semibold mb-4 block">
            Admisiones Abiertas
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            The Freedom Fellowship
          </h2>
          <div className="inline-block px-6 py-2 bg-gradient-to-r from-yellow-500/20 to-yellow-600/20 border border-yellow-500/30 rounded-full">
            <span className="text-yellow-400 font-semibold">Beca Libertad</span>
          </div>
        </div>

        {/* Main card */}
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-white/5 to-transparent border border-white/10 rounded-3xl p-8 md:p-12 backdrop-blur-sm">
          {/* Description */}
          <div className="text-center mb-12">
            <p className="text-xl text-gray-300 mb-6 leading-relaxed max-w-3xl mx-auto">
              Abrimos <span className="text-white font-bold">300 becas Libertad</span> para emprendedores y profesionales que quieren escalar su mente, su negocio y su libertad.
            </p>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Las becas cubren entre el <span className="text-teal-400 font-bold">50% y el 100%</span> del valor del programa.
            </p>
            <div className="mb-8">
              <p className="text-lg text-gray-400 mb-2">Valor del programa:</p>
              <p className="text-4xl font-bold text-white">US$7,500</p>
            </div>
            <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto">
              Si tu perfil es aprobado, obtienes acceso completo a todas las sesiones en vivo, a los mentores y a la comunidad privada de Urpe.
            </p>
          </div>

          {/* Benefits */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="text-center group">
              <div className="inline-flex p-4 bg-teal-500/10 rounded-xl border border-teal-500/20 mb-3 transition-all duration-300 group-hover:bg-teal-500/20 group-hover:border-teal-500/40 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-teal-500/30">
                <Award className="text-teal-400 animate-icon-bounce group-hover:animate-icon-spin" size={28} />
              </div>
              <h4 className="text-white font-semibold mb-1">Certificado</h4>
              <p className="text-sm text-gray-400">Verificable en LinkedIn</p>
            </div>
            <div className="text-center group">
              <div className="inline-flex p-4 bg-teal-500/10 rounded-xl border border-teal-500/20 mb-3 transition-all duration-300 group-hover:bg-teal-500/20 group-hover:border-teal-500/40 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-teal-500/30" style={{ animationDelay: '0.2s' }}>
                <Users className="text-teal-400 animate-icon-bounce group-hover:animate-icon-pulse-scale" size={28} />
              </div>
              <h4 className="text-white font-semibold mb-1">Comunidad</h4>
              <p className="text-sm text-gray-400">Acceso de por vida</p>
            </div>
            <div className="text-center group">
              <div className="inline-flex p-4 bg-teal-500/10 rounded-xl border border-teal-500/20 mb-3 transition-all duration-300 group-hover:bg-teal-500/20 group-hover:border-teal-500/40 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-teal-500/30" style={{ animationDelay: '0.4s' }}>
                <CheckCircle className="text-teal-400 animate-icon-bounce group-hover:animate-icon-check" size={28} />
              </div>
              <h4 className="text-white font-semibold mb-1">Mentorship</h4>
              <p className="text-sm text-gray-400">Directo con emprendedores</p>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-10 py-5 bg-gradient-to-r from-teal-500 to-teal-600 text-black font-semibold rounded-full hover:from-teal-400 hover:to-teal-500 transition-all duration-300 shadow-2xl shadow-teal-500/30 hover:shadow-teal-500/50 hover:scale-105 text-lg"
            >
              <MessageCircle size={22} />
              <span>Aplicar por WhatsApp</span>
            </a>
          </div>

          {/* Legal note */}
          <p className="text-xs text-gray-500 text-center mt-8">
            * Beca sujeta a evaluación de perfil. Cupos limitados a 20 participantes por ciclo.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Admissions;
